import Link from "next/link"
import { useState, useEffect, useRef } from "react"

const PensionCalculator = () => {

    const tierRef = useRef()
    const facRef = useRef()
    const [showMessage, setShowMessage] = useState(0)
    
    // Service Credit State for validation
    const [serviceCreditRetirement, setServiceCreditRetirement] = useState({
        tier1: "",
        tierA: "",
        tierB: "",
        tierC: "",
        tierD: "",
        safetyA: "",
        safetyB: "",
        safetyC: "",
        safetyD: "",
    });
    
    const [showServiceCreditError, setShowServiceCreditError] = useState(false);

    // Validation: Check if user has both Tier 1/A AND Tier B/C/D
    useEffect(() => {
        const num = (v) => parseFloat((v || "").toString().replace(/[^\d.]/g, "")) || 0;
        
        // Check if Tier 1 or Tier A has value (General or Safety)
        const hasTier1OrA = 
            num(serviceCreditRetirement.tier1) > 0 || 
            num(serviceCreditRetirement.tierA) > 0 || 
            num(serviceCreditRetirement.safetyA) > 0;
        
        // Check if Tier B, C, or D has value (General or Safety)
        const hasTierBCD = 
            num(serviceCreditRetirement.tierB) > 0 || 
            num(serviceCreditRetirement.tierC) > 0 || 
            num(serviceCreditRetirement.tierD) > 0 || 
            num(serviceCreditRetirement.safetyB) > 0 || 
            num(serviceCreditRetirement.safetyC) > 0 || 
            num(serviceCreditRetirement.safetyD) > 0;
        
        setShowServiceCreditError(hasTier1OrA && hasTierBCD);
        
    }, [serviceCreditRetirement]);

    const handleFC = (e) => {
        const inputClean = e.target.value.replace(/[^\d.]/g, '').replace(/\.(?=.*\.)/g, '')
        const output = inputClean
        const currentTier = tierRef.current.value
        if((currentTier === 'GenTier1' || 
        currentTier === 'GenTierA' || 
        currentTier === 'GenTierB' || 
        currentTier === 'SafetyTierA' || 
        currentTier === 'SafetyTierB'
        ) && output > 30000) {
            setShowMessage(1)
        } else if ((currentTier === 'GenTierC' || currentTier === 'GenTierD') && output > 13311.08) {
            setShowMessage(2)
        } else if((currentTier === 'SafetyTierC' || currentTier === 'SafetyTierD') && output > 15973.25) {
            setShowMessage(3)
        } else {
            setShowMessage(0)
        }
    }

    return (
        <div className="calculatorPage">
         <form id="form1">
                <div
                    className="calc"
                    cellPadding="0"
                    cellSpacing="0"
                    width="100%"
                >
                    <div>
                        <div className="StepOne">
                            <div className="calcStep">Step 1:</div>
                            <div
                                className="calcQuestion"
                                align="left"
                            >
                                Select your SDCERA classification and tier
                            </div>

                            <div
                                className="calcInput"
                                style={{
                                    verticalAlign: "top",
                                    textAlign: "right",
                                }}
                            >
                                {/* Removed empty <label> wrapper; aria-label added directly */}
                                <select
                                    ref={tierRef}
                                    name="DropDownClassification"
                                    id="DropDownClassification"
                                    aria-label="SDCERA classification and tier"
                                >
                                    <option text="General, Tier I" value="GenTier1">General, Tier I</option>
                                    <option text="General, Tier A" value="GenTierA">General, Tier A</option>
                                    <option text="General, Tier B" value="GenTierB">General, Tier B</option>
                                    <option text="General, Tier C" value="GenTierC">General, Tier C</option>
                                    <option text="General, Tier D" value="GenTierD">General, Tier D</option>
                                    <option text="Safety, Tier A" value="SafetyTierA">Safety, Tier A</option>
                                    <option text="Safety, Tier B" value="SafetyTierB">Safety, Tier B</option>
                                    <option text="Safety, Tier C" value="SafetyTierC">Safety, Tier C</option>
                                    <option text="Safety, Tier D" value="SafetyTierD">Safety, Tier D</option>
                                </select>
                                {/* Hidden radio buttons — aria-label added, empty <label> wrappers removed */}
                                <input
                                    type="radio"
                                    id="RadioButtonGeneral"
                                    aria-label="General"
                                    text="General"
                                    style={{ display: "none" }}
                                    defaultChecked="True"
                                    groupname="Classification"
                                />
                                &nbsp;&nbsp;
                                <input
                                    type="radio"
                                    id="RadioButtonSafety"
                                    aria-label="Safety"
                                    text="Safety"
                                    style={{ display: "none" }}
                                    groupname="Classification"
                                />
                            </div>
                        </div>

                        <div className="StepTwo">
                        <div className="calcStep">Step 2:</div>
                        <div
                            className="calcQuestion"
                            align="left"
                        >
                            Select your age at retirement
                        </div>

                        <div
                            className="calcInput"
                            style={{
                            verticalAlign: "top",
                            textAlign: "right",
                            }}
                        >
                            {/* aria-label added directly — no label element present */}
                            <select
                            name="DropDownListAgeYear"
                            id="DropDownListAgeYear"
                            aria-label="Age at retirement - year"
                            ></select>
                            &nbsp;
                            <select
                            name="DropDownListAgeQuarter"
                            id="DropDownListAgeQuarter"
                            aria-label="Age at retirement - quarter"
                            >
                            <option value=".00">.00</option>
                            <option value=".25">.25</option>
                            <option value=".50">.50</option>
                            <option value=".75">.75</option>
                            </select>
                            &nbsp;
                        </div>
                        </div>

                        <div className="StepThree">
                        <div className="calcStep">Step 3:</div>

                        <div
                            className="calcQuestion"
                            align="left"
                        >
                            Enter your final average monthly
                            compensation
                        </div>

                        <div
                            className="calcInput"
                            style={{
                            verticalAlign: "top",
                            textAlign: "right",
                            }}
                        >
                            {/* Removed empty <label> wrapper; aria-label added directly */}
                            <input
                                ref={facRef}
                                type="text"
                                placeholder="$1,000"
                                id="TextBoxFinalComp"
                                width="115px"
                                className="currency"
                                aria-label="Final average monthly compensation"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Enter your final average monthly compensation"
                                onKeyUp={handleFC}
                            />
                            <br />
                        </div>
                        </div>

                        <div className="StepFour">
                        <div className="calcStep">Step 4:</div>

                        <div
                            className="calcQuestion"
                            align="left"
                        >
                            Enter the service credit you will have
                            on your retirement date. You can enter
                            multiple numbers if you have service
                            credit from different tiers
                        </div>
                        <div
                            className="calcInput"
                            align="right"
                            style={{ paddingRight: "11px" }}
                        >
                            <div
                            className="StepFourTable"
                            cellPadding="1px"
                            cellSpacing="0"
                            style={{
                                border: "1px solid #cccccc",
                                paddingBottom: "5px",
                                paddingRight: "1px",
                            }}
                            >
                            {showServiceCreditError && (
                                <div style={{
                                    backgroundColor: "#f8d7da",
                                    border: "1px solid #f5c6cb",
                                    color: "#721c24",
                                    padding: "15px",
                                    borderRadius: "4px",
                                    fontWeight: "bold",
                                    textAlign: "center"
                                }}>
                                    ⚠️Your calculation requires two final average monthly compensation calculations. Please contact SDCERA at 619-515-6800 for your custom estimate.
                                </div>
                            )}
                            <div>
                                <div>
                                <div
                                    className="calcGeneral"
                                    style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    }}
                                >
                                    <h2 className="h4">General</h2>
                                    <div className="calcInputTier">
                                    <div className="TableTier">Tier <br /> I</div>
                                    <div className="TableTier">Tier <br />A</div>
                                    <div className="TableTier">Tier <br />B</div>
                                    <div className="TableTier">Tier <br />C</div>
                                    <div className="TableTier">Tier <br />D</div>
                                    {/* Removed empty <label> wrappers; aria-label added to each input */}
                                    <div className="TableTier">
                                        &nbsp;
                                        <input
                                            type="text"
                                            id="TextBoxTier1SC"
                                            aria-label="General Tier I service credit"
                                            size="4"
                                            value={serviceCreditRetirement.tier1}
                                            onChange={(e) => setServiceCreditRetirement({ ...serviceCreditRetirement, tier1: e.target.value })}
                                        />
                                    </div>
                                    <div className="TableTier">
                                        &nbsp;
                                        <input
                                            type="text"
                                            id="TextBoxTierASC"
                                            aria-label="General Tier A service credit"
                                            size="4"
                                            value={serviceCreditRetirement.tierA}
                                            onChange={(e) => setServiceCreditRetirement({ ...serviceCreditRetirement, tierA: e.target.value })}
                                        />
                                    </div>
                                    <div className="TableTier">
                                        &nbsp;
                                        <input
                                            type="text"
                                            id="TextBoxTierBSC"
                                            aria-label="General Tier B service credit"
                                            size="4"
                                            value={serviceCreditRetirement.tierB}
                                            onChange={(e) => setServiceCreditRetirement({ ...serviceCreditRetirement, tierB: e.target.value })}
                                        />
                                    </div>
                                    <div className="TableTier">
                                        &nbsp;
                                        <input
                                            type="text"
                                            id="TextBoxTierCSC"
                                            aria-label="General Tier C service credit"
                                            size="4"
                                            value={serviceCreditRetirement.tierC}
                                            onChange={(e) => setServiceCreditRetirement({ ...serviceCreditRetirement, tierC: e.target.value })}
                                        />
                                    </div>
                                    <div className="TableTier">
                                        &nbsp;
                                        <input
                                            type="text"
                                            id="TextBoxTierDSC"
                                            aria-label="General Tier D service credit"
                                            size="4"
                                            value={serviceCreditRetirement.tierD}
                                            onChange={(e) => setServiceCreditRetirement({ ...serviceCreditRetirement, tierD: e.target.value })}
                                        />
                                    </div>
                                    </div>
                                </div>
                                <div
                                    className="calcSafety"
                                    style={{
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    background: "#eeeeee",
                                    borderLeft: "1px solid #cccccc",
                                    }}
                                >
                                    <h2 className="h4">Safety</h2>
                                    <div className="calcInputTier">
                                    <div className="TableTier" style={{ background: "#eeeeee" }}>Tier <br />A</div>
                                    <div className="TableTier" style={{ background: "#eeeeee" }}>Tier <br />B</div>
                                    <div className="TableTier" style={{ background: "#eeeeee" }}>Tier <br />C</div>
                                    <div className="TableTier" style={{ background: "#eeeeee" }}>Tier <br />D</div>
                                    <div className="TableTier" style={{ background: "#eeeeee" }}>&nbsp;</div>
                                    {/* Removed empty <label> wrappers; aria-label added to each input */}
                                    <div className="TableTier" style={{ background: "#eeeeee" }}>
                                        &nbsp;
                                        <input
                                            type="text"
                                            id="TextBoxSafetySC"
                                            aria-label="Safety Tier A service credit"
                                            size="4"
                                            value={serviceCreditRetirement.safetyA}
                                            onChange={(e) => setServiceCreditRetirement({ ...serviceCreditRetirement, safetyA: e.target.value })}
                                        />
                                    </div>
                                    <div className="TableTier" style={{ background: "#eeeeee" }}>
                                        &nbsp;
                                        <input
                                            type="text"
                                            id="TextBoxSafetyTierBSC"
                                            aria-label="Safety Tier B service credit"
                                            size="4"
                                            value={serviceCreditRetirement.safetyB}
                                            onChange={(e) => setServiceCreditRetirement({ ...serviceCreditRetirement, safetyB: e.target.value })}
                                        />
                                    </div>
                                    <div className="TableTier" style={{ background: "#eeeeee" }}>
                                        &nbsp;
                                        <input
                                            type="text"
                                            id="TextBoxSafetyTierCSC"
                                            aria-label="Safety Tier C service credit"
                                            size="4"
                                            value={serviceCreditRetirement.safetyC}
                                            onChange={(e) => setServiceCreditRetirement({ ...serviceCreditRetirement, safetyC: e.target.value })}
                                        />
                                    </div>
                                    <div className="TableTier" style={{ background: "#eeeeee" }}>
                                        &nbsp;
                                        <input
                                            type="text"
                                            id="TextBoxSafetyTierDSC"
                                            aria-label="Safety Tier D service credit"
                                            size="4"
                                            value={serviceCreditRetirement.safetyD}
                                            onChange={(e) => setServiceCreditRetirement({ ...serviceCreditRetirement, safetyD: e.target.value })}
                                        />
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>

                            <br />
                        </div>
                        </div>

                        <div className="StepFive">
                        <div className="calcStep"></div>

                        <div
                            className="calcInput"
                            style={{ textAlign: "right" }}
                        >
                            <button
                                type="button"
                                id="ButtonCalculate"
                                text="Calculate"
                            >
                                Calculate
                            </button>
                        </div>
                        <div className="calcQuestion"></div>
                        </div>
                        <div className="StepSix">
                            <div
                                colSpan="3"
                                style={{ paddingRight: "10px" }}
                                align="right"
                            >
                                {/* <a aria-label="Calculator" name="calculator" ></a> */}
                                <div
                                    id="PanelUnmodifiedBenefit"
                                    style={{ display: "none" }}
                                    align="right"
                                >
                                    <div
                                        id="Unmod"
                                        style={{
                                            position: "relative",
                                            visibility: "visible",
                                            zIndex: "400",
                                        }}
                                    >
                                        <br className="pbreak" />
                                        
                                        <div
                                            className="resultTable"
                                            cellPadding="0"
                                            cellSpacing="0"
                                        >
                                            
                                        <div>
                                            <div className="quartReportTitle">
                                                Member unmodified monthly
                                                benefit amount
                                            </div>
                                            <div
                                                className="calcContent"
                                                style={{
                                                    borderTop: "3px solid #ededc5",
                                                }}
                                            >
                                            <div id="unmodMobe">
                                                <span id="LabelMonthlyBenefit"></span>
                                                &nbsp;
                                            </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                className="quartReportTitle"
                                                style={{
                                                    borderBottom:
                                                    "2px solid #1f3664",
                                                }}
                                            >
                                                Upon Member death, 60%
                                                survivor continuance
                                            </div>
                                            <div
                                            className="calcContent"
                                            style={{
                                                borderBottom:
                                                "2px solid #1f3664",
                                            }}
                                            >
                                            <div id="unmodCont">
                                                <span id="LabelSurvivorContinuance"></span>
                                                &nbsp;
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="StepMessage" style={{visibility: showMessage === 0 && `hidden`}}>
                            <div className="FAC_message_area">
                                {(showMessage === 1) &&
                                    <span>
                                        <strong>General and Safety Tier I, A and B:</strong> Your pension may be subject to compensation limits. 
                                        The maximum FAC for your tier is <strong>​$30,000</strong>. Visit our <Link href="/members/benefits/excess-benefit-plan">compensation limits page</Link> to learn more. If you entered SDCERA membership before July 1, 1996, please contact SDCERA at 619-515-6800 for a custom estimate.
                                    </span>
                                }
                                {showMessage === 2 &&
                                    <span>
                                        <strong>General Tier C and D:</strong> Your pension may be subject to compensation limits. 
                                        The maximum FAC for your tier is <strong>​$13,311.08</strong>. Visit our <Link href="/members/benefits/excess-benefit-plan">compensation limits page</Link> to learn more. If you entered SDCERA membership before July 1, 1996, please contact SDCERA at 619-515-6800 for a custom estimate.
                                    </span>
                                }
                                {showMessage === 3 &&
                                    <span>
                                        <strong>Safety Tier C and D:</strong> Your pension may be subject to compensation limits. 
                                        The maximum FAC for your tier is <strong>$15,973.25</strong>. Visit our <Link href="/members/benefits/excess-benefit-plan">compensation limits page</Link> to learn more. If you entered SDCERA membership before July 1, 1996, please contact SDCERA at 619-515-6800 for a custom estimate.
                                    </span>
                                }
                            </div>
                        </div>
                        
                    </div>
                </div>
            </form>
        </div>
    )
}

export default PensionCalculator